import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import Shimmer from 'react-shimmer-effect';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import { ColorWhite } from '../../../shared/GlobalStyles';

const AuthorAvatarContainer = styled('div')`
  align-items: center;
  border: none;
  border-radius: 50%;
  color: transparent;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

const AuthorInfoContainer = styled('div')`
  align-items: center;
  border-radius: 24px;
  display: flex;
`;

const AuthorName = styled('div')`
  color: transparent;
  font-size: 13px;
  line-height: 19.5px;
  margin-right: 12px;
  @media screen and (max-width: 480px) {
    margin-right: 4px;
  }
`;

const CommentCount = styled('div')`
  align-items: center;
  display: flex;
`;

const CommentCountText = styled('div')`
  color: transparent;
  font-size: 13px;
  line-height: 19.5px;
`;

const CommentIconContainer = styled('div')`
  align-items: center;
  display: flex;
  height: 28px;
  justify-content: center;
  margin-right: 12px;
  width: 28px;
  @media screen and (max-width: 480px) {
    margin-right: 4px;
  }
`;

const CommentsAndAuthorDiv = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .Shimmer-shimmer-0-1-1 {
    display: inline-flex!important;
  }
`;

const CommentsContainer = styled('div')`
  border-radius: 24px;
`;

const DateAndOptionsDiv = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
`;

const DummyCommentBox = styled('div')`
  border-radius: 24px;
  height: 32px;
  margin-top: 12px;
  width: 100%;
`;

const EntryDate = styled('div')`
  border-radius: 24px;
  color: transparent;
  font-size: 16px;
  line-height: 24px;
`;

const EntryText = styled('div')`
  border-radius: 24px;
  color: transparent;
  font-size: 19px;
  line-height: 28.5px;
  margin-bottom: 16px;
  overflow-x: hidden;
`;

const EntryTitle = styled('div')`
  border-radius: 24px;
  color: transparent;
  font-size: 19px;
  font-weight: 700;
  line-height: 28.5px;
  margin-bottom: 16px;
`;

const JournalEntryContainer = styled('div')`
  background-color: ${ColorWhite};
  border-radius: 10px;
  box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  padding: 20px;
  position: relative;
`;

const JournalEntryLoading = ({ journalEntry }) => {
  const {
    authorUserName,
    body,
    date,
    title,
  } = journalEntry;

  return (
    <JournalEntryContainer>
      <DateAndOptionsDiv>
        <Shimmer>
          <EntryDate>{date}</EntryDate>
        </Shimmer>
      </DateAndOptionsDiv>
      <Shimmer>
        <EntryTitle title={title}>{title || <em>Untitled</em>}</EntryTitle>
      </Shimmer>
      <Shimmer>
        <EntryText>
          {body}
        </EntryText>
      </Shimmer>
      <CommentsAndAuthorDiv>
        <Shimmer className='comments-author-shimmer'>
          <CommentsContainer>
            <CommentCount>
              <CommentIconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={18}
                  icon='comment'
                  color='transparent'
                  aria-hidden='true'
                />
              </CommentIconContainer>
              <CommentCountText>
                0 Comments
              </CommentCountText>
            </CommentCount>
          </CommentsContainer>
        </Shimmer>
        <Shimmer>
          <AuthorInfoContainer>
            <AuthorName>
              {authorUserName}
            </AuthorName>
            <AuthorAvatarContainer>
              o
            </AuthorAvatarContainer>
          </AuthorInfoContainer>
        </Shimmer>
      </CommentsAndAuthorDiv>
      <Shimmer>
        <DummyCommentBox />
      </Shimmer>
    </JournalEntryContainer>
  );
};

JournalEntryLoading.propTypes = {
  journalEntry: PropTypes.shape({
    authorUserName: PropTypes.string,
    body: PropTypes.string,
    date: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default JournalEntryLoading;
